import FilterAmountStep from "../unit/FilterAmountStep";
import CustomFilterText from "../unit/CustomFilterText";

const getVendorsListFilters = () => [
  <CustomFilterText key="id" label="Ven #" source="id" defaultValue="" />,
  <CustomFilterText
    key="sName"
    label="Organization"
    source="sName"
    defaultValue=""
  />,
  <CustomFilterText key="sCity" label="City" source="sCity" defaultValue="" />,
  <CustomFilterText
    key="sState"
    label="State"
    source="sState"
    defaultValue=""
  />,
  //   <CustomFilterText key="sZip" label="Zip" source="sZip" defaultValue="" />,
  <CustomFilterText
    key="sContactName"
    label="Contact Name"
    source="sContactName"
    defaultValue=""
  />,
  //   <CustomFilterText
  //     key="sContactEmail"
  //     label="Contact Email"
  //     source="sContactEmail"
  //     defaultValue=""
  //   />,
  //   <CustomFilterText
  //     key="sContactPhone"
  //     label="Contact Phone"
  //     source="sContactPhone"
  //     defaultValue=""
  //   />,
  //   <FilterAmountStep
  //     key="iMaxLoanAmount"
  //     source="iMaxLoanAmount"
  //     label="Max Loan Amount"
  //     amountOptions={[
  //       { id: "1", name: "<$1000" },
  //       { id: "2", name: "$1000-$5000" },
  //       { id: "3", name: "$5000-$10,000" },
  //       { id: "4", name: "$10,000-$20,000" },
  //       { id: "5", name: ">$20,000" },
  //     ]}
  //     before="and"
  //   />,
  //   <FilterAmountStep
  //     key="iMaxApplicationFee"
  //     source="iMaxApplicationFee"
  //     label="Application Fee"
  //     amountOptions={[
  //       { id: "1", name: "<$1000" },
  //       { id: "2", name: "$1000-$5000" },
  //       { id: "3", name: "$5000-$10,000" },
  //       { id: "4", name: "$10,000-$20,000" },
  //       { id: "5", name: ">$20,000" },
  //     ]}
  //     before="and"
  //   />,
];

export default getVendorsListFilters;
